import { Card, CardContent } from '@estac1/ui';

interface KpiCardProps {
  label: string;
  value: string;
  hint?: string;
}

export const KpiCard = ({ label, value, hint }: KpiCardProps) => (
  <Card>
    <CardContent className="space-y-1 pt-6">
      <p className="text-xs font-medium uppercase tracking-wide text-muted-fg">{label}</p>
      <p className="text-2xl font-semibold">{value}</p>
      {hint && <p className="text-xs text-muted-fg">{hint}</p>}
    </CardContent>
  </Card>
);
